
import Spinner from "@/components/Spinner/Spinner";
import { Button } from "@/components/UiElements";
import updateTheme from "@/services/ThemeService/updateTheme";
import addTheme from "@/services/ThemeService/addTheme";
import { Theme ,HistoryTheme} from "@/types/theme";
import { ChangeEvent, useEffect, useState } from "react";
import { toast } from "react-toastify";
import getThemeHistory from "@/services/ThemeService/getThemeHistory";
import revertTheme from "@/services/ThemeService/revertTheme";
import CustomDropdown, { Option } from "@/components/Dropdown/Dropdown";
import {formatDateFromStringWithHour} from "@/utils/formatDate";

type PricingFormProps = {
  oldTheme?: Theme
  onUpdateSuccess?: () => void
  closeModal?: () => void
}
 type DropdownHistoryTheme = {
    label: string;
    value: any;
} & HistoryTheme;

const ThemeRevertForm = ({
                           oldTheme,
                           onUpdateSuccess,
                           closeModal
                         }: PricingFormProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState(oldTheme?.title || '');
  const [themeHistory, setThemeHistory] = useState<DropdownHistoryTheme[]>([]);
  const [selectHistory, setSelectHistory] = useState<DropdownHistoryTheme>();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    loadHistoryTheme()
  }, [])


  const loadHistoryTheme = async () => {
    // @ts-ignore
    const resultHistory = await getThemeHistory(oldTheme?.id, page);
    if (resultHistory && resultHistory.contents.length > 0) {
      const newHistory = resultHistory.contents.map((i: any) => ({
        ...i,
        label: formatDateFromStringWithHour(i.created_at),
        value: i.id
      }));
      setThemeHistory(prevData => [...prevData, ...newHistory]);
      setPage(prevPage => prevPage + 1);
    } else {
      setHasMore(false);
    }
  };



  const handleRevertTheme = async () => {
    if (!oldTheme?.id || !selectHistory) {
      return;
    }
    setIsLoading(true)
    console.log("revert",selectHistory)
    await revertTheme(oldTheme.id,selectHistory.id);
    onUpdateSuccess && onUpdateSuccess()
    toast.success('Theme reverted successfully')
    setIsLoading(false)
    closeModal && closeModal()
  }

  return (
      <div className={'flex flex-col justify-center p-5'}>
        <h2 className="text-lg font-extrabold my-3">Revert Theme</h2>
          {themeHistory.length>0 ? <>
        <div className="flex justify-start">
            <div className='w-full my-3'>
            <p className="text-gray-700 text-xs">Select date from the list</p>
             <CustomDropdown
                  options={themeHistory}
                  onSelectedOptionChange={(option) => setSelectHistory(option as DropdownHistoryTheme)}
                  hasMore={hasMore}
                  loadMore={loadHistoryTheme}
              />
          </div>
        </div>
        <Button disabled={isLoading} onClick={handleRevertTheme}>{isLoading ? <Spinner /> : 'Revert Theme'}</Button>
      </>
          :
              <p>No history to revert</p>
          }
</div>
  )
}

export default ThemeRevertForm